export default "__VITE_ASSET__D52emOu1__"